<section class="content companies-records-page">
  <div class="content-block companies-records-page__content">
    <div class="block-header companies-records-page__header">
      <app-breadcrumb [title]="'MENUITEMS.ORGANIZATION.TEXT' | translate"
                      [items]="[('companiesRecordsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>
    <div class="row companies-records-page__row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 companies-records-page__column">
        <app-master-table [title]="'companiesRecordsCatalog.title' | translate"
                          [columnDefinitions]="columnDefinitions"
                          [dataSource]="dataSource"
                          [filters]="tableFilters"
                          [isLoading]="isLoading"
                          [tableMaxHeight]="'100%'"
                          [useServerData]="true"
                          [searchValue]="searchValue"
                          [totalItems]="totalItems"
                          [currentPage]="page"
                          [pageSize]="perPage"
                          [pageSizeOptions]="pageSizeOptions"
                          [showCheckbox]="true"
                          [disableRowClickToEdit]="true"
                          [enableRowClick]="false"
                          [exportFileName]="'companies-records'"
                          [actions]="actions"
                          (add)="handleAdd()"
                          (details)="handleView($event)"
                          (edit)="handleEdit($event)"
                          (delete)="handleDelete($event)"
                          (bulkDelete)="handleBulkDelete($event)"
                          (refresh)="loadData(true)"
                          (searchChange)="onSearchChange($event)"
                          (filtersChange)="onFiltersChange($event)"
                          (pageChange)="onPageChange($event)"
                          (actionTriggered)="handleAction($event)">
        </app-master-table>
      </div>
    </div>
  </div>
</section>
